import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardLike = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 15.75,
			fill: "white",
			stroke: "#D2DCE2",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 23.0267C13.0663 20.6304 11.2515 19.0426 10.1591 17.7285C9.0826 16.4334 8.75 15.4554 8.75 14.2424C8.75 12.2985 10.2978 10.75 12.2353 10.75C13.8255 10.75 14.7165 11.6162 15.439 12.4305L16 13.0626L16.561 12.4305C17.2835 11.6162 18.1745 10.75 19.7647 10.75C21.7022 10.75 23.25 12.2985 23.25 14.2424C23.25 15.4554 22.9174 16.4334 21.8409 17.7285C20.7485 19.0426 18.9336 20.6304 16 23.0267Z",
			fill: "white",
			stroke: "url(#paint0_linear_216_21232)",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_216_21232",
			x1: 16,
			y1: 10,
			x2: 16,
			y2: 24,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF699C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FE5763"
			})]
		}) })
	]
});
export default SvgCardLike;
